






























import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class PageFooter extends Vue {
  @Getter('app/getAppVersion') appVersion!: string;
}
